import React from 'react';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarProps,
  SidebarProvider,
  SidebarRail,
} from '@/components/ui/sidebar';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import TenantSwitcher from './TenantSwitcher';
import NavMain from './NavMain';
import NavUser from './NavUser';
import { ILink } from './types';

interface AppSidebarProps extends SidebarProps {
  navItems: ILink[];
}

const AppSidebar: React.FC<AppSidebarProps> = ({
  navItems,
  children,
  ...props
}) => {
  const { session } = useAuthSessionStore();

  return (
    <SidebarProvider>
      <Sidebar collapsible="icon" {...props}>
        <SidebarHeader>
          <TenantSwitcher />
        </SidebarHeader>
        <SidebarContent>
          <NavMain items={navItems} />
        </SidebarContent>
        <SidebarFooter>
          {session && <NavUser session={session} />}
        </SidebarFooter>
        <SidebarRail />
      </Sidebar>
      <SidebarInset className="bg-muted">{children}</SidebarInset>
    </SidebarProvider>
  );
};

export default AppSidebar;
